export default __webpack_public_path__ + "static/media/logo-sm.6b8fafbe.svg";